import * as XLSX from 'xlsx-js-style';
import { WorkBook } from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import { FundsAndPerformanceExportExcelWrapper } from 'src/app/domain/organization/components/organization-overview/utils';
import { getPreparedData } from './mapping';
import { defineColumnsLen, setColumnWidth, withHeaderStyling } from '../../utils';
import { fitToColumn } from '../financial-statement/utils';

export class FundsAndPerformanceTemplate implements ExcelTemplate {
  export(data: FundsAndPerformanceExportExcelWrapper): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData: FundsAndPerformanceExportExcelWrapper): XLSX.WorkSheet {
    const headers = HEADERS_FOR_DISPLAY_ORG_OVERVIEW;
    const preparedData = getPreparedData(exportExcelData, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexes = [7, 16, 20];
    whiteSpaceIndexes.forEach((index) => setColumnWidth(sheet, index, 1.5));
    const largeColumns = [0, 4, 5, 17, 18, 21];
    const bigColumnLen = 21;
    largeColumns.forEach((index) => setColumnWidth(sheet, index, bigColumnLen));
    const len = defineColumnsLen(this.prepareDataToDefineNameColumnLen(exportExcelData)) + 3;
    if (len > bigColumnLen) {
      setColumnWidth(sheet, 0, len);
    }

    return withHeaderStyling(sheet);
  }


  private prepareDataToDefineNameColumnLen(data: FundsAndPerformanceExportExcelWrapper): string[] {
    return data.funds.map((fund) => fund.name);
  }
};

const HEADERS_FOR_DISPLAY_ORG_OVERVIEW = ['Entity', 'Vintage', 'Reporting period', 'Total commitment', 'Contribution received', 'Unfunded commitment', 'NAV+Unf. Comm.', null,
  'NAV & Distribution', 'NAV', 'Distribution inc. carry', 'Net gain/(loss)', 'TVPI', 'DPI', 'RVPI', 'Net IRR', null,
  'Total carried interest', 'Realized carried interest', 'Unrealized carried interest', null,
  'NAV & Distribution', 'NAV', 'Distribution', 'Net gain/(loss)', 'TVPI', 'DPI', 'RVPI', 'Net IRR'];


export const HEADERS_FOR_LOGIC_ORG_OVERVIEW = [
  'Entity', 'Vintage', 'Reporting period', 'Total commitment', 'Contribution received', 'Unfunded commitment', 'NAV+Unf. Comm.', 'empty',
  'NAV & Distribution', 'NAV', 'Distribution inc. carry', 'Net gain/(loss)', 'TVPI', 'DPI', 'RVPI', 'Net IRR', 'empty(1)',
  'Total carried interest', 'Realized carried interest', 'Unrealized carried interest', 'empty(2)',
  'NAV & Distribution(1)', 'NAV(1)', 'Distribution', 'Net gain/(loss)(1)', 'TVPI(1)', 'DPI(1)', 'RVPI(1)', 'Net IRR(1)',
];

export const FIRST_ROW_HEADERS_ORG_OVERVIEW = [
  '', '', '', '', '', '', '', null,
  '', '', '', '', 'Before carry', '', '', '', null,
  '', '', '', null,
  '', '', '', '', 'After carry', '', '', '',
];
